export default "__VITE_PUBLIC_ASSET__25a044ea__"